// removed by extract-text-webpack-plugin
module.exports = {"btn":"styles__btn___28ctJ"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/ConsumptionProfile/components/ButtonLoading/styles.css
// module id = 2928
// module chunks = 0